var map = {
	"./1.jpg": 73,
	"./butter1.jpg": 74,
	"./butter2.jpg": 75,
	"./butter3.jpg": 76,
	"./milk1.jpg": 77,
	"./milk2.jpg": 78,
	"./milk3.jpg": 79,
	"./shake1.jpg": 80,
	"./shake2.jpg": 81,
	"./shake3.jpg": 82,
	"./shake4.jpg": 83,
	"./shop_bg.jpg": 84,
	"./yogurt1.jpg": 85,
	"./yogurt2.jpg": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;